import { DropdownMenuSeparator } from "../../../ui/dropdown-menu";

export const SeparatorItem = () => {
  return <DropdownMenuSeparator />;
};
